<template>
  <v-form ref="addEditSessionDetailsFormRef">
    <v-row class="pa-3">
      <v-col cols="12" md="12">
        <div class="text-subtitle-1 font-weight-bold">Session details</div>
      </v-col>
      <!-- <UploadImages eventCategory="subEvent" /> -->

      <!--Start: Sub event format--->
      <v-col cols="12" md="12">
        <div class="text-body-2 font-weight-medium">Session format</div>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-radio-group v-model="currentSession.type" row class="mt-0">
          <v-radio
            value="online"
            label="Online"
            off-icon="mdi-circle-outline"
            on-icon="mdi-check-circle"
            >Online</v-radio
          >
          <v-radio
            value="in-person"
            label="In-person"
            off-icon="mdi-circle-outline"
            on-icon="mdi-check-circle"
            >In-person</v-radio
          >
          <v-radio
            value="hybrid"
            label="Hybrid"
            off-icon="mdi-circle-outline"
            on-icon="mdi-check-circle"
            >Hybrid</v-radio
          >
        </v-radio-group>
      </v-col>
      <!--End: Sub event format--->

      <!---Start: Sub event details--->
      <v-col cols="12" md="12" class="pt-0">
        <div class="text-body-2 font-weight-medium">Session name</div>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          dense
          outlined
          placeholder="eg: Melbourne Start-up Annual Pitch Night"
          v-model="currentSession.name"
          :rules="requiredRules"
        />
      </v-col>
      <v-col cols="12" md="12" class="pt-0">
        <v-row dense>
          <v-col cols="12" md="12" class="pt-0">
            <div class="text-body-2 font-weight-medium">Date and Time</div>
          </v-col>
          <!-- <v-col cols="12" md="12">
            <v-alert
              text
              width="50%"
              color="primary"
              dense
              v-if="isDateTimePickerReadOnly"
            >
              <div class="d-flex justif-center align-center">
                <v-icon color="primary" class="mr-2">mdi-alert-circle</v-icon>
                <div>{{ alertText }}</div>
              </div>
            </v-alert>
          </v-col> -->
          <v-col cols="6" class="py-0">
            <vc-date-picker
              v-model="range"
              mode="dateTime"
              is-range
              :minDate="minStartDate"
              @input="handleBlur"
              is-required
              :select-attribute="attribute"
              :drag-attribute="attribute"
              :input-debounce="20000"
              :popover="{ placement: 'top', visibility: 'click' }"
              :timezone="currentSubEvent.timezone"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <v-text-field
                  :value="getEventDateTime(inputValue)"
                  v-on="inputEvents.start"
                  outlined
                  dense
                  :readonly="true"
                  :rules="requiredRules"
                  validate-on-blur
                  @change.native="inputEvents.updateValue($event.target.value)"
                  placeholder="Select date and time"
                />
              </template>
            </vc-date-picker>
          </v-col>
          <!-- <v-col cols="12" md="6" class="my-0 py-0" hidden>
            <div v-if="currentSession.startDateTime != null">
              {{ getEventActivationAndExpirationDateTime() }}
            </div>
          </v-col> -->

          <v-col
            cols="6"
            md="12"
            class="pt-0"
            v-if="
              currentSession.type == 'online' || currentSession.type == 'hybrid'
            "
          >
            <div class="text-body-2 font-weight-medium">Event join link</div>
          </v-col>
          <v-col
            class="py-0"
            cols="6"
            md="6"
            v-if="
              currentSession.type == 'online' || currentSession.type == 'hybrid'
            "
          >
            <v-text-field
              dense
              outlined
              placeholder="Zoom or Google Meet URL"
              v-model="currentSession.joiningLink"
            />
          </v-col>

          <v-col
            class="pt-0"
            cols="12"
            md="12"
            v-if="
              currentSession.type == 'in-person' ||
              currentSession.type == 'hybrid'
            "
          >
            <div class="text-body-2 font-weight-medium">Location</div>
          </v-col>
          <v-col
            class="py-0"
            cols="6"
            md="6"
            v-if="
              currentSession.type == 'in-person' ||
              currentSession.type == 'hybrid'
            "
          >
            <v-text-field
              dense
              outlined
              placeholder="e.g. State Library Victoria, 328 Swanston St, Melbourne 3000"
              v-model="currentSession.address"
            />
          </v-col>
          <!-- <v-col cols="6"> </v-col> -->
          <v-col cols="12" md="12" hidden>
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-space-between">
                <!-- { 'cursor-disabled': isEditMode },    :disabled="isEditMode" -->
                <v-switch
                  :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline',
                    ,
                  ]"
                  hide-details
                  v-model="currentSession.hasAskOfferNote"
                  label="Allow attendees to add AskOffer and General Notes"
                  style="font-size: 14px !important"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    The AskOffer and General Notes sections allow attendees to
                    ask for assistance from fellow attendees and offer their
                    expertise in the field they specialize in, as well as add
                    any notes they would like to share. This option cannot be
                    changed after the link has been created.
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">About this session</div>
          </v-col>
          <v-col class="py-0" cols="6" md="6">
            <v-textarea
              outlined
              placeholder="Description about this session"
              v-model="currentSession.description"
            />
          </v-col>

          <v-col class="pt-0" cols="12" md="12">
            <div class="text-body-2 font-weight-medium">
              URL to sitemap (optional)
            </div>
          </v-col>

          <v-col cols="6" md="6" class="py-0">
            <v-text-field
              dense
              outlined
              v-model="currentSession.sitemapURL"
              placeholder="URL to sitemap"
              hint=""
            />
          </v-col>

          <v-col cols="12" md="12">
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-start">
                <!--,     -->
                <v-switch
                  :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline'
                  ]"
                  
                  hide-details
                  v-model="currentSession.enableChatroom"
                  label="Enable chat room"
                  style="font-size: 14px !important"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    Enable chat room for all attendees attending the event.
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12">
            <v-row no-gutters>
              <v-col cols="6" class="d-flex align-center justify-start">
                <v-switch
                    :class="[
                    'mt-0 mb-2 text-body-2 font-weight-medium mc-checkbox d-inline',
                    ,
                    { 'cursor-disabled': isEditMode },
                  ]"
                    hide-details
                    v-model="currentSession.enableContentFeed"
                    @change="change"
                    label="Enable Content Feed"
                    style="font-size: 14px !important"
                ></v-switch>

                <v-tooltip bottom max-width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-5" size="22">
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>
                    Enable a newsfeed section within this session page in the app for purposes such as related content (e.g. presentation slides or videos) for this session.
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="currentSession.enableContentFeed" cols="12" md="12" class="pa-0">
            <v-col cols="6" md="12" class="pt-0">
              <div class="text-body-2 font-weight-medium">Who can post on this feed?</div>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-autocomplete
                  v-model="currentSession.sessionPostCreationAccess"
                  :items="contentFeedTypes"
                  outlined
                  dense
              ></v-autocomplete>
            </v-col>
          </v-col>
        </v-row>
      </v-col>

      <!---End: Sub event details--->

      <!-- <AddEditEventDetails eventCategory="subEvent" /> -->
    </v-row>
  </v-form>
</template>

<script>
// import UploadImages from "../UploadImages";
import AddEditEventDetails from "../AddEditEventDetails";
import { mapGetters } from "vuex";
import AddNewImage from "@/components/AddNewImage";
import UploadImageDialog from "@/components/UploadImageDialog";
import AvatarButton from "@/components/AvatarButton";

export default {
  components: {
    // UploadImages,
    AddEditEventDetails,
    AddNewImage,
    UploadImageDialog,
    AvatarButton,
  },
  data() {
    return {
      contentFeedTypes: [{text:"Anyone", value: "anyone"}, {text: "Admins Only", value: "admin"}, {text: "Speakers in this session only", value: "speakersOnly"}, {text: "Admins and Speakers in this session",value:"adminAndSpeakers" }],
      requiredRules: [(v) => !!v || "This field is requried"],
      timezoneItems: [],
      range: {
        start: "",
        end: "",
      },
      attribute: {
        highlight: {
          start: {
            style: {
              backgroundColor: "#F15E31", //primary
            },
            contentStyle: {
              color: "#ffffff", // color of the text
            },
          },
          base: {
            style: {
              backgroundColor: "#FEECE8", // tint
            },
          },
          end: {
            style: {
              backgroundColor: "#F15E31", // primary
            },
            contentStyle: {
              color: "#ffffff", // color of the text
            },
          },
        },
      },
      isValid: false,
      isDateTimePickerReadOnly: false,
    };
  },
  created() {
    this.runInitialSetup();
  },
  computed: {
    ...mapGetters(["currentSession", "currentSubEvent"]),
    minStartDate() {
      return new Date().toISOString().slice(0, 10);
    },
    isEditMode() {
      return !this.currentSession.isCreationInProgress;
    },
  },
  methods: {
    change() {
      if(!this.currentSession.enableContentFeed) {
        this.currentSession.sessionPostCreationAccess = "";
      }
    },
    handleBlur() {
      this.currentSession.startDateTime = this.range.start;
      this.currentSession.endDateTime = this.range.end;

      //Start: UNCOMMENT LATER ON
      this.$refs.addEditEventDetailsForm.resetValidation();
    },
    getEventDateTime(inputValue) {
      if (inputValue.start != null && inputValue.end != null)
        return inputValue.start + " to " + inputValue.end;
      return "";
    },
    getEventActivationAndExpirationDateTime() {
      return (
        "EventConnect link will automatically activate on " +
        this.currentSession.getFormattedEventActivationDateTime() +
        " and expire on " +
        this.currentSession.getFormattedEventExpirationDateTime() +
        " (" +
        this.currentSubEvent.timezone +
        ")"
      );
    },
    validatePage() {
      let isValid = this.$refs.addEditSessionDetailsFormRef.validate();
      return isValid;
    },
    runInitialSetup() {
      if (
        this.currentSession.getStatus() == "Active" ||
        this.currentSession.getStatus() == "Past"
      )
        this.isDateTimePickerReadOnly = true;

      if (this.currentSession.startDateTime == null) {
        console.log(
          " this.currentSession.startDateTime check: ",
          this.currentSession.startDateTime
        );
        this.currentSession.startDateTime = this.currentSubEvent.startDateTime;
        console.log(
          "  this.currentSession.startDateTime after set: ",
          this.currentSession.startDateTime
        );
      }
      if (this.currentSession.endDateTime == null) {
        console.log(
          " this.currentSession.endDateTime check: ",
          this.currentSession.endDateTime
        );
        this.currentSession.endDateTime = this.currentSubEvent.endDateTime;
        console.log(
          "  this.currentSession.endDateTime after set: ",
          this.currentSession.endDateTime
        );
      }

      //Set the start and end date-time values
      this.range.start = this.currentSession.startDateTime;
      this.range.end = this.currentSession.endDateTime;

      //Get list of available time zones
      this.timezoneItems = Intl.supportedValuesOf("timeZone");

      //If user hasn't selected a timezone, set a default value based on browsers timezone
      if (!this.currentSession.timezone) {
        this.currentSession.timezone =
          Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    },
  },
};
</script>

<style>
</style>